export default class APIError extends Error {
  constructor(status_code, message) {
    super(message);
    this.status_code = status_code;
    this.name = "API - Error";
    this.status = status_code;
    this.error = true;
  }
}
